module.exports = __webpack_public_path__ + "static/media/default-img.f065b10c.png";